<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="demo-form-inline">
      <el-col class="gray1">
        <el-form-item label="服务组编号">
          <el-input v-model="form.name" style="width:160px"></el-input>
        </el-form-item>
        <el-form-item label="搜索内容" label-width="80px">
          <el-input v-model="form.content" style="width:160px"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-top-right">导出</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addZuFun">新增服务组</el-button>
          <el-button type="primary" @click="searchData">查询</el-button>
          <el-button type="danger" @click="clearForm">清空查询条件</el-button>
        </el-form-item>
      </el-col>
    </el-form>

    <!-- table -->
    <div v-loading="loading" element-loading-text="拼命加载中......">
      <el-table
        :data="list"
        style="width: 100%"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column prop="listone" label="序号" min-width="50" align="center"></el-table-column>
        <el-table-column prop="listtwo" label="组编号" min-width="80" align="center"></el-table-column>
        <el-table-column prop="listthree" label="主要服务人员" min-width="100" align="center"></el-table-column>
        <el-table-column prop="listfour" label="主要服务人员联系方式" min-width="150" align="center"></el-table-column>
        <el-table-column prop="listfive" label="从属服务人员" min-width="100" align="center"></el-table-column>
        <el-table-column prop="listsix" label="从属服务人员联系方式" min-width="150" align="center"></el-table-column>
        <el-table-column prop="listseven" label="主要人员服务站点" min-width="150" align="center"></el-table-column>
        <el-table-column prop="listeight" label="从属人员服务站点" min-width="150" align="center"></el-table-column>
        <el-table-column prop="listnight" label="服务名称" min-width="120" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-edit"
              title="修改"
              @click="handleEdit(scope.$index, scope.row)"
            >修改</el-button>
            <el-button
              type="danger"
              size="mini"
              title="删除"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        layout="total, prev, pager, next"
        :total="totalPage"
        :page-size="10"
        align="center"
        class="fenye"
      ></el-pagination>
    </div>

    <!-- 添加 -->
    <el-dialog :title="addZuFormTitle" :visible.sync="addZuDialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
      <el-form ref="addZuForm" :model="addZuForm" :rules="addZuFormRules" label-width="160px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务组编号" prop="zuNo">
              <el-input
                v-model.trim="addZuForm.listtwo"
                placeholder="请输入"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="主要服务人员" prop="mainName">
              <el-input
                v-model.trim="addZuForm.listthree"
                placeholder="请输入姓名"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主要服务人员联系方式" prop="mainPhone">
              <el-input
                v-model.trim="addZuForm.listfour"
                placeholder="请输入"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="从属服务人员" prop="secondName">
              <el-input
                v-model.trim="addZuForm.listfive"
                placeholder="请输入姓名"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="从属服务人员联系方式" prop="secondPhone">
              <el-input
                v-model.trim="addZuForm.listsix"
                placeholder="请输入"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="服务名称" prop="serviceName">
              <el-input
                v-model.trim="addZuForm.listseven"
                placeholder="请输入"
                maxlength="14"
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" :loading="submitZuAdd" @click="submitZuAddFun(addZuForm)">确 定</el-button>
        <el-button type="warning" @click="addZuDialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 删除服务组 -->
    <el-dialog title="删除服务组" :visible.sync="deleteZuDialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <span style="margin-left:34%">{{deleteZuMessage}}</span>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="deleteZuFun()">确 定</el-button>
        <el-button type="warning" @click="deleteZuDialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      form: {},
      loading: false,
      list: [],
      pageNo: 1,
      totalPage: 0,
      submitZuAdd: false,
      addZuDialogFormVisible: false,
      addZuForm: {},
      addZuFormRules: {},
      addZuFormTitle: "新增服务组",
      deleteZuDialogFormVisible: false,
      deleteZuMessage: ""
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #FFFFFF";
      } else {
        return "background-color: #FAFAFA";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#CCCCCC;color:#333333;font-weight: 600;";
      }
    },
    addList() {
      this.list = [];

      var familyNames = new Array(
        "赵",
        "钱",
        "孙",
        "李",
        "周",
        "吴",
        "郑",
        "王",
        "冯",
        "陈",
        "褚",
        "卫",
        "蒋",
        "沈",
        "韩",
        "杨",
        "朱",
        "秦",
        "尤",
        "许",
        "何",
        "吕",
        "施",
        "张",
        "孔",
        "曹",
        "严",
        "华",
        "金",
        "魏",
        "陶",
        "姜",
        "戚",
        "谢",
        "邹",
        "喻",
        "柏",
        "水",
        "窦",
        "章",
        "云",
        "苏",
        "潘",
        "葛",
        "奚",
        "范",
        "彭",
        "郎",
        "鲁",
        "韦",
        "昌",
        "马",
        "苗",
        "凤",
        "花",
        "方",
        "俞",
        "任",
        "袁",
        "柳",
        "酆",
        "鲍",
        "史",
        "唐",
        "费",
        "廉",
        "岑",
        "薛",
        "雷",
        "贺",
        "倪",
        "汤",
        "滕",
        "殷",
        "罗",
        "毕",
        "郝",
        "邬",
        "安",
        "常",
        "乐",
        "于",
        "时",
        "傅",
        "皮",
        "卞",
        "齐",
        "康",
        "伍",
        "余",
        "元",
        "卜",
        "顾",
        "孟",
        "平",
        "黄",
        "和",
        "穆",
        "萧",
        "尹"
      );
      var givenNames = new Array(
        "子璇",
        "淼",
        "国栋",
        "夫子",
        "瑞堂",
        "甜",
        "敏",
        "尚",
        "国贤",
        "贺祥",
        "晨涛",
        "昊轩",
        "易轩",
        "益辰",
        "益帆",
        "益冉",
        "瑾春",
        "瑾昆",
        "春齐",
        "杨",
        "文昊",
        "东东",
        "雄霖",
        "浩晨",
        "熙涵",
        "溶溶",
        "冰枫",
        "欣欣",
        "宜豪",
        "欣慧",
        "建政",
        "美欣",
        "淑慧",
        "文轩",
        "文杰",
        "欣源",
        "忠林",
        "榕润",
        "欣汝",
        "慧嘉",
        "新建",
        "建林",
        "亦菲",
        "林",
        "冰洁",
        "佳欣",
        "涵涵",
        "禹辰",
        "淳美",
        "泽惠",
        "伟洋",
        "涵越",
        "润丽",
        "翔",
        "淑华",
        "晶莹",
        "凌晶",
        "苒溪",
        "雨涵",
        "嘉怡",
        "佳毅",
        "子辰",
        "佳琪",
        "紫轩",
        "瑞辰",
        "昕蕊",
        "萌",
        "明远",
        "欣宜",
        "泽远",
        "欣怡",
        "佳怡",
        "佳惠",
        "晨茜",
        "晨璐",
        "运昊",
        "汝鑫",
        "淑君",
        "晶滢",
        "润莎",
        "榕汕",
        "佳钰",
        "佳玉",
        "晓庆",
        "一鸣",
        "语晨",
        "添池",
        "添昊",
        "雨泽",
        "雅晗",
        "雅涵",
        "清妍",
        "诗悦",
        "嘉乐",
        "晨涵",
        "天赫",
        "玥傲",
        "佳昊",
        "天昊",
        "萌萌",
        "若萌"
      );

      var fuwuType = new Array(
        "上门送餐",
        "门店送餐",
        "上门助洁",
        "门店助洁",
        "上门助医",
        "门店助医",
        "远程看护"
      );
      var Range = 6;
      var Rand = Math.random();

      for (
        var i = 10 * (this.pageNo - 1);
        i < 10 * (this.pageNo - 1) + 10;
        i++
      ) {
        var familyName = familyNames[i];
        var givenName = givenNames[i];
        var name = familyName + givenName;
        var familyName2 = familyNames[40 - i];
        var givenName2 = givenNames[40 - i];
        var name2 = familyName2 + givenName2;
        this.list.push({
          listone: i + 1,
          listtwo: "00" + (i + 1),
          listthree: name,
          listfour: this.getMoble(),
          listfive: name2,
          listsix: this.getMoble(),
          listseven: "武汉市武昌区和平区",
          listeight: "楠山养老社区",
          listnight: fuwuType[i % 7]
        });
      }
      this.totalPage = 20;
    },
    getMoble() {
      var prefixArray = new Array(
        "130",
        "131",
        "132",
        "133",
        "135",
        "137",
        "138",
        "170",
        "187",
        "189"
      );
      var i = parseInt(10 * Math.random());
      var prefix = prefixArray[i];
      for (var j = 0; j < 8; j++) {
        prefix = prefix + Math.floor(Math.random() * 10);
      }
      return prefix;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.addList();
    },
    handleEdit(index, row) {
      this.addZuFormTitle = "修改服务组";
      this.addZuDialogFormVisible = true;
      this.addZuForm = row;
    },
    handleDelete(index, row) {
      this.deleteZuDialogFormVisible = true;
      this.deleteZuMessage = "是否确认删除服务组"+row.listtwo;
    },
    deleteZuFun() {
      this.deleteZuDialogFormVisible = false;
    },
    addZuFun() {
      this.addZuDialogFormVisible = true;
    },
    searchData() {
      this.list = [];
      var familyNames = new Array("赵", "钱", "尹");
      var givenNames = new Array("子璇", "淼", "若萌");

      var fuwuType = new Array(
        "上门送餐",
        "门店送餐",
        "上门助洁",
        "门店助洁",
        "上门助医",
        "门店助医",
        "远程看护"
      );
      var Range = 6;
      var Rand = Math.random();

      for (var i = 0; i < 2; i++) {
        var familyName = familyNames[i];
        var givenName = givenNames[i];
        var name = familyName + givenName;
        var familyName2 = familyNames[2 - i];
        var givenName2 = givenNames[2 - i];
        var name2 = familyName2 + givenName2;
        this.list.push({
          listone: i + 1,
          listtwo: "00" + (i + 1),
          listthree: name,
          listfour: this.getMoble(),
          listfive: name2,
          listsix: this.getMoble(),
          listseven: "武汉市武昌区青山区",
          listeight: "楠山养老社区",
          listnight: fuwuType[i % 7]
        });
      }
      this.totalPage = 2;
    },
    clearForm() {
      this.form = {};
    },
    submitZuAddFun(form) {},
    addPeopleFun() {
      //ServicePeopleAdd
      bus.$emit("homePage", {
        type: "jump",
        path: "/ServicePeopleAdd",
        title: "服务人员添加"
      });
    }
  },
  mounted() {
    this.addList();
  }
};
</script>
<style lang="scss" scoped>
.gray1 {
  background: #f5f5f5;
  padding-left: 10px;
  padding-top: 15px;
}
.gray2 {
  background: #f5f5f5;
  padding-left: 10px;
  padding-bottom: 15px;
}
</style>